import {Component, EventEmitter, ViewChild, OnDestroy} from '@angular/core';
import {PortfolioService} from './portfolio.service';
import {SharedService} from '../../shared-components/shared.service';
import {StudentService} from '../../shared-components/student/student.service';
import {Portfolio} from './portfolio.model';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import {System} from '../../shared-components/System';
import {AutoUnsubscribe} from 'ngx-auto-unsubscribe';
import {FilterPortfolio} from './portfolio-filter.pipe';
import {UserService} from '../../shared-components/user/user.service';
import {AddPortfolioModalComponent} from './add-portfolio-modal/add-portfolio-modal.component';
import {formatDate} from '@angular/common';
import {TylerMatTableDataSource} from '../../shared-components/angular-material/extended.class';
import {DeletePortfolioModalComponent} from './delete-portfolio-modal/delete-portfolio-modal.component';
import {EditPortfolioModalComponent} from './edit-portfolio-modal/edit-portfolio-modal.component';
import {PortfolioFilter} from './portfolio-filter';
import {StudentDocumentAccessHistoryComponent} from '../student-documents/student-document-access-history/student-document-access-history.component';

@AutoUnsubscribe()
@Component({
    selector: 'portfolio',
    providers: [PortfolioService],
    templateUrl: './portfolio.component.html',
    styleUrls: [
        './portfolio.component.css'
    ]
})
export class PortfolioComponent implements OnDestroy {

    studentPortfolios;
    isStaffMember = false;
    portfolioFilter = new PortfolioFilter();
    previousPortfolioFilter = new PortfolioFilter();
    columnsToDisplay = ['Added', 'Category', 'Description', 'FileName', 'Size', 'Year', 'AddBy', 'RecentAccessHistory'];
    portfolioSource = new TylerMatTableDataSource();
    filterPortfolio = new FilterPortfolio();
    showFilter: boolean = false;
    clearFilterEvent = new EventEmitter<any>();

    @ViewChild(MatSort) set sort(value: MatSort) {
        this.portfolioSource.sort = value;
        this.portfolioSource.sortingDataAccessor = (item: any, property: string) => {

            if (property == 'Added') {
                return new Date(item.Added).getTime();
            } else {
                return this.portfolioSource.defaultSortingAccessor(item, property);
            }
        };
    }

    constructor(
        private portfolioService: PortfolioService,
        private sharedService: SharedService,
        private dialog: MatDialog,
        private studentService: StudentService,
        private userService: UserService
    ) {
        if (this.userService.userType == 1 && this.userService.selectedStudentInfoPortal == undefined) {
            this.isStaffMember = true;
            if (this.isStaffMember) {
                // If Staff add new column Actions
                this.columnsToDisplay.push('Actions');
            }
        }
        this.studentService.selectedStudentStream$.subscribe(student => {
            this.studentPortfolios = undefined;
            this.getPortfolios();
        });
    }

    getPortfolios() {
        this.portfolioService.getPortfolios(this.studentService.selectedStudent.Id).subscribe(data => {
            this.studentPortfolios = data;
            this.portfolioSource.data = this.studentPortfolios;
            this.filterChanged();
        });
    }

    filterChanged() {
        this.portfolioSource.data = this.filterPortfolio.transform(this.studentPortfolios, this.portfolioFilter);
    }

    classFiltered() {
        if ((this.portfolioFilter.Name != undefined && this.portfolioFilter.Name.length > 0) ||
            (this.portfolioFilter.Desc != undefined && this.portfolioFilter.Desc.length > 0) ||
            (this.portfolioFilter.Category != undefined && this.portfolioFilter.Category.length > 0) ||
            (this.portfolioFilter.Year != undefined && this.portfolioFilter.Year.length > 0) ||
            this.portfolioFilter.FromDate != undefined || this.portfolioFilter.ToDate != undefined || this.portfolioFilter.Added ||
            (this.portfolioFilter.AddBy != undefined && this.portfolioFilter.AddBy.length > 0)) {
            return true;
        } else {
            return false;
        }
    }

    showFilterClick() {
        this.showFilter = !this.showFilter;
        this.previousPortfolioFilter = JSON.parse(JSON.stringify(this.portfolioFilter));
    }

    addClick() {
        this.dialog.open(AddPortfolioModalComponent, {
            minWidth: 300,
            minHeight: 200,
            disableClose: true,
            autoFocus: false
        }).afterClosed().subscribe(result => {
            if (result == 'Success') {
                this.getPortfolios();
            }
        });
    }

    isEven(rowId: number) {
        return (rowId % 2) == 0;
    }

    clearFilter(fromFooter) {
        this.portfolioFilter = new PortfolioFilter();
        this.portfolioSource.filters = [];
        if (!fromFooter) {
        } else {
            this.portfolioSource.removeAllFilters();
            this.clearFilterEvent.emit();
        }
        this.filterChanged();
    }

    closeFilter() {
        this.showFilter = false;
    }

    viewPortfolio(portfolio: Portfolio) {
        // Audit document view if parent/contact
        if (this.userService.userType == 2) {
            this.portfolioService.auditStudentPortfolioDocument(portfolio.Id).subscribe(res => {
                System.viewFileFromBase(portfolio.FileBase64, portfolio.FileMimeType, portfolio.FilePath);
                // Get the portfolios again because the audit history changed
                this.getPortfolios();
            });
        } else {
            System.viewFileFromBase(portfolio.FileBase64, portfolio.FileMimeType, portfolio.FilePath);
        }
    }

    getDateFormatted(date) {
        return formatDate(date, 'MM/dd/yy', 'en-US');
    }

    editPortfolioDocumentClick(document) {
        this.dialog.open(EditPortfolioModalComponent, {
            minWidth: 520,
            minHeight: 200,
            data: document,
            disableClose: true,
            autoFocus: false
        }).afterClosed().subscribe(result => {
            if (result == 'Success') {
                this.getPortfolios();
            }
        });
    }

    deletePortfolioDocumentClick(document) {
        document.AddedBy = this.userService.currentUser.MemberId;
        this.dialog.open(DeletePortfolioModalComponent, {
            minWidth: 520,
            minHeight: 200,
            disableClose: true,
            autoFocus: false
        }).afterClosed().subscribe(result => {
            if (result == 'Yes') {
                this.portfolioService.deleteStudentPortfolio(document).subscribe(res => {
                    if (res.ok) {
                        this.getPortfolios();
                    }
                });
            }
        });
    }

    ngOnDestroy() {
    }

    studentAccessHistoryClick(row) {
        const dialogRef = this.dialog.open(StudentDocumentAccessHistoryComponent, {
            disableClose: true,
            autoFocus: false,
            data: {AccessHistory: row.RecentAccessHistory}
        });
    }

    round(num: number) {
        return Math.round(num);
    }
}
